import React from 'react';
import Hero from '../components/Hero';
import Card from '../components/Card';
import { Activity, ShieldCheck, HeartPulse, UserPlus, Users2, Stethoscope, Zap, Award, Briefcase } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './Insurance.css';

const HealthInsurance = () => {
    const { t } = useLanguage();

    const healthPlans = [
        { key: 'ft_health_indiv', icon: UserPlus, desc: 'Highest medical coverage for yourself with paperless claim settlement.' },
        { key: 'ft_health_family', icon: Users2, desc: 'One plan to cover your entire family with extensive health cover.' },
        { key: 'ft_health_critical', icon: HeartPulse, desc: 'Lump sum payout for critical illnesses to manage treatments.' },
        { key: 'ft_health_senior', icon: ShieldCheck, desc: 'Tailored health insurance for your parents with low waiting periods.' },
        { key: 'ft_health_group', icon: Briefcase, desc: 'Employee-focused medical coverage for a healthier productive team.' },
        { key: 'ft_health_accident', icon: Zap, desc: 'Financial protection against accidental injuries and disabilities.' },
    ];

    return (
        <div className="insurance-page">
            <Hero 
                title={t('ft_health')}
                subtitle="Your health is your real wealth. Experience premium medical coverage with cash-less hospitalisation across India."
                bgGradient={true}
                image="/assets/health-hero.png"
            />

            <section className="section-padding container">
                <div className="text-center mb-60">
                    <h2 className="section-title">Health Plans for Every Need</h2>
                    <p className="section-subtitle">We go beyond simple coverage to ensure you get the best medical care when it matters most.</p>
                </div>
                
                <div className="grid grid-3">
                    {healthPlans.map((plan, i) => (
                        <Card 
                            key={i}
                            title={t(plan.key)}
                            description={plan.desc}
                            icon={plan.icon}
                            link="/contact"
                        />
                    ))}
                </div>
            </section>

            <section className="features-grid section-padding" style={{ background: '#F8F9FA' }}>
                <div className="container">
                    <div className="text-center mb-60">
                        <h2 className="section-title">Elite Benefits</h2>
                    </div>
                    <div className="grid grid-2">
                        <div className="feature-item">
                            <Activity className="feature-icon" />
                            <h4>Cashless Hospitalization</h4>
                            <p>Network of 10,000+ top hospitals in India offering seamless cashless treatment.</p>
                        </div>
                        <div className="feature-item">
                            <Zap className="feature-icon" />
                            <h4>No-Claim Bonus</h4>
                            <p>Get up to 50% increase in your sum insured for every claim-free year.</p>
                        </div>
                        <div className="feature-item">
                            <Stethoscope className="feature-icon" />
                            <h4>Free Health Checkups</h4>
                            <p>Annual health check-ups at zero cost to stay proactive about your health.</p>
                        </div>
                        <div className="feature-item">
                            <Award className="feature-icon" />
                            <h4>Tax Benefits (80D)</h4>
                            <p>Enjoy tax deductions on health insurance premiums paid for yourself and parents.</p>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container text-center section-padding">
                <div className="cta-box glass">
                    <h3>Get Instant Health Quote</h3>
                    <p>Tell us your age and needs for an optimized healthcare plan comparison.</p>
                    <button className="btn btn-primary">Compare Quotes</button>
                </div>
            </div>
        </div>
    );
};

export default HealthInsurance;
